import { Auth } from "aws-amplify";
import React, { useEffect } from "react";

const withAuth = (Component: any) => (props: any) => {
  const [valid, setValid] = React.useState<boolean>(false);
  const [userGroups, setUserGroups] = React.useState<string[]>([]);
  const [loading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    getAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAuth = async () => {
    try {
      let currentUser = await Auth.currentAuthenticatedUser();
      setUserGroups(currentUser.signInUserSession.accessToken.payload["cognito:groups"]);
      setValid(true);
    } catch (error) {
      setValid(false);
      setUserGroups([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return null;

  return <Component {...props} isValid={valid} userGroups={userGroups}/>;
};
export default withAuth;
